import React, { PureComponent } from "react";
import Proptypes from "prop-types";

export interface IErrorBoundaryProps {
  fallback?: JSX.Element;
}

export interface IErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends PureComponent<
  IErrorBoundaryProps,
  IErrorBoundaryState
> {
  static propTypes = {
    fallback: Proptypes.any,
  };

  static defaultProps = {
    fallback: <h1 className="tc red">Something went wrong</h1>,
  };

  constructor(props: IErrorBoundaryProps) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error: any): IErrorBoundaryState {
    return {
      hasError: true,
    };
  }

  render(): JSX.Element | null | undefined | {} {
    const { hasError } = this.state;
    const { fallback, children } = this.props;
    return hasError ? fallback : children;
  }
}

export default ErrorBoundary;
